import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, Output } from "@angular/core";
import { Subject } from "rxjs";
import { StartPayoutAgeFormFieldComponent } from "../../../shared/components/form-fields/start-payout-age-form-field/start-payout-age-form-field.component";
import { FmsPipe } from "../../../shared/pipes/fms.pipe";

@Component({
  selector: "app-simulation-age",
  templateUrl: "./simulation-age.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [StartPayoutAgeFormFieldComponent, FmsPipe],
})
export class SimulationAgeComponent implements OnDestroy {
  @Output()
  public selectionChange = new EventEmitter();

  private readonly destroy$: Subject<void> = new Subject<void>();

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  public onPayoutAgeChange(): void {
    this.selectionChange.emit();
  }
}
